import React from 'react';
import EasyProcess from '../../../assets/Service-icon/EasyProcess.svg';
import WideCoverage from '../../../assets/Service-icon/WideCoverage.svg';
import CustomPlans from '../../../assets/Service-icon/CustomPlans.svg';
import HassleFreeClaims from '../../../assets/Service-icon/HassleFreeClaims.svg';

const Steps = () => {
  const options = [
    {
      id: 1,
      img: EasyProcess,
      desc: 'Get your travel insurance in just a few simple steps with an easy online process.',
    },
    {
      id: 2,
      img: WideCoverage,
      desc: 'Enjoy wide coverage including medical emergencies, trip cancellations, and lost baggage.',
    },
    {
      id: 3,
      img: HassleFreeClaims,
      desc: 'Benefit from a quick and hassle-free claim settlement process.',
    },
    {
      id: 4,
      img: CustomPlans,
      desc: 'Choose from customizable plans tailored to your travel needs and budget.',
    },
  ];

  return (
    <div className='mb-10 px-4 py-10 text-center'>
      {/* Main Heading */}
      <h1 className='mb-12 text-3xl font-extrabold leading-snug text-gray-900 md:text-6xl'>
        Secure Your Trip with Travel Insurance
      </h1>

      {/* Grid */}
      <div className='mx-auto grid max-w-7xl grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-4'>
        {options.map((item) => (
          <div
            key={item.id}
            className='service_card flex flex-col items-center rounded-lg'
          >
            <img
              src={item.img}
              alt={item.desc}
              className='mb-4 h-24 w-24 object-contain'
            />

            <p className='text-justify leading-relaxed text-gray-700'>{item.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Steps;
